import templateUrl from './payroll-financials-detail.component.html'

export const PayrollFinancialsDetailComponent = {
    controller: PayrollFinancialsDetailController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        payrollFinancials: "<",
        aggregates: "<",
        sortColumns: "<",
        compareAggregates: "<?",
        onSetSort: "&"
    }
};

function PayrollFinancialsDetailController($scope) {
    'ngInject';
    const vm = this;
    vm.$onInit = $onInit;
    vm.payrollFinancials;
    vm.aggregates;
    vm.columns;
    vm.sortColumns;
    vm.compareAggregates;
    vm.isSortingByField = isSortingByField;
    vm.columnClass = columnClass;
    vm.onSetSort;

    vm.pageNumber = 1;
    vm.pageSize = 25;

    function $onInit() {
        vm.columns = [{
            title: "End Date",
            field: "EndDate",
            sortable: true
        }, {
            title: "Owner",
            field: "Owner",
            sortable: true
        }, {
            title: "Show Days",
            field: "NumberOfShowDays",
            sortable: true
        }, {
            title: "Rep Hours",
            field: "SalesRepHours",
            sortable: true
        }, {
            title: "Hrs Per Show",
            field: "SalesRepHoursPerShow",
            sortable: true
        }, {
            title: "Payout",
            field: "NetPayout",
            sortable: true
        }, {
            title: "Net Profit",
            field: "GrossProfit",
            sortable: true
        }, {
            title: "NP%",
            field: "GrossProfitPercent",
            sortable: true
        }, {
            title: "SF Pyrl",
            field: "SalesRepGrossPay",
            sortable: true
        }, {
            title: "%pyrl",
            field: "SalesRepGrossPayPercent",
            sortable: true
        }, {
            title: "Payout HR",
            field: "NetPayoutRate",
            sortable: true
        }, {
            title: "Rep/Hr",
            field: "SalesRepGrossPayRate",
            sortable: true
        }, {
            title: "NP/Hr",
            field: "GrossProfitRate",
            sortable: true
        }, {
            title: "Total Dollars",
            field: "NetWorthTotalDollars",
            sortable: true
        }, {
            title: "PO",
            field: "PromotingOwner",
            sortable: false
        }, {
            title: "NC",
            field: "NationalConsultant",
            sortable: false
        }];

        // Change the page number if the payroll financials change.
        $scope.$watch(function () {
            return vm.payrollFinancials;
        }.bind(vm), function () {
            if ((vm.pageNumber - 1) * vm.pageSize > vm.payrollFinancials.length) {
                vm.pageNumber = 1;
            }
        });
    }

    function getColumn(field) {
        return vm.sortColumns.filter(function (column) {
            return column.field === field;
        })[0];
    }

    function isSortingByField(field) {
        const column = getColumn(field);
        return !!column;
    }

    function columnClass(field) {
        const column = getColumn(field);
        if (!column) {
            return {};
        }

        return {
            'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
            'glyphicon fas fa-sort-amount-down': column.dir < 0
        };
    }
}
